/**
 * How an order is said out loud: "Table 4", "Counter 12", "Tab 6".
 *
 * The same words on the list of orders and at the top of the order itself, so
 * the one a waiter tapped is visibly the one that opened.
 */

import { useFloor, type Order } from '@restaurant/api-client';

/** Every table's label by its id, on this site. */
export function useTableLabels(locationId: string | undefined): Map<string, string> {
  const floor = useFloor(locationId);
  const labels = new Map<string, string>();
  for (const plan of floor.data ?? []) {
    for (const table of plan.tables) labels.set(table.id, table.label);
  }
  return labels;
}

export function orderName(
  order: Pick<Order, 'table_id' | 'service_mode' | 'number'>,
  tableLabel: Map<string, string>,
): string {
  if (order.table_id && tableLabel.has(order.table_id)) {
    return `Table ${tableLabel.get(order.table_id)}`;
  }
  if (order.service_mode === 'counter') return `Counter ${order.number}`;
  return `Tab ${order.number}`;
}
